import { render, staticRenderFns } from "./OrderInfoQryDetail.vue?vue&type=template&id=33a77986&scoped=true&"
import script from "./OrderInfoQryDetail.vue?vue&type=script&lang=js&"
export * from "./OrderInfoQryDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoQryDetail.vue?vue&type=style&index=0&id=33a77986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a77986",
  null
  
)

export default component.exports